'use client';

import { SnackbarProvider, closeSnackbar } from "notistack";
import { useDispatch } from "react-redux";
import { clearNotifcation } from "@package/api/slices/AlertMessageSlice";

export function SnackbarProviderWrapper({ children }) {
  const dispatch = useDispatch();

  const clearNotificationData = () => {
    dispatch(clearNotifcation({ messageToaster: false, toasterType: "", toasterMessage: "" }));
  }

  return (
    <SnackbarProvider
      maxSnack={3}
      // autoHideDuration={3000}
      onClose={clearNotificationData}
    >
      {children}
    </SnackbarProvider>
  );
}
